export default "__VITE_ASSET__BVqAE_I6__"